<template>
    <div class="pt-2">
      <v-btn color="white" style="color: black;" block v-if="selectMode==false" @click="initializeSelectMode">+ Add Organization</v-btn>
      <div v-else class="d-flex">
        <v-combobox  outlined v-model="networkowner_id" :items="optionsList"  label="Select Organization...">
        </v-combobox>
        <v-text-field 
        outlined
            class="ml-2"
            label="Enter Capacity Limit (%)" 
            v-model.number="capacity_limit_pct"            
            type="number"
        /> 
        <v-btn color="white" class="ml-2 mt-1" style="color: black;" large @click="itemSelected" >+ ADD</v-btn>
      </div>      
    </div>  
  </template>
  
  <script>
  import {api, srvApi, srvApiNoAuth, PATH, getAssetUrl} from "src/api/index";
  
  export default {
    props: {
      owner_id: {
        type: Number,
        required: false,
        default: -1
      }
    },
    data() {
      return {        
        optionsList: [],        
        selectMode: false,

        networkowner_id: null,
        capacity_limit_pct: null,
      }
    },
    watch: {
      async owner_id(newVal) {        
        const rsp = await srvApi.get(PATH.NETWORKOWNER_ASOPTIONS);     
        this.optionsList.splice(0, this.optionsList.length);
        this.optionsList.push(...rsp.data.filter(o=>o.value != newVal));
      }
    },
    methods: {
      initializeSelectMode() {
        this.networkowner_id=null;        
        this.capacity_limit_pct=null;
        this.selectMode=true;
      },
      itemSelected() {
        this.$emit('itemselected', {
            networkowner_id: this.networkowner_id.value,
            capacity_limit_pct: this.capacity_limit_pct
        });        
        this.selectMode=false;
      }
    },
    async mounted() {
      const rsp = await srvApi.get(PATH.NETWORKOWNER_ASOPTIONS);        
      this.optionsList.push(...rsp.data.filter(o=>o.value != this.owner_id));
    }
  }
  </script>
  
  <style>
  
  </style>
  